import React, { useState, useEffect } from 'react';
import _ from 'lodash';
import utils from './utils';
import services from '@/services';
import utils_1 from '@/utils/utils';
import dd from '@/utils/dd';
import './index.scss';
import DefaultGoodsList from './DefaultGoodsList';
import Carousel from './Carousel';
import CustomizeImg from './CustomizeImg';
import RedPacket from './RedPacket';
import BannerImg from './BannerImg';
import CenterSecond from './CenterSecond';
import CenterThird from './CenterThird';
import VideoView from './VideoView';
import BKGoods from './BKGoods';
import Loading from '../Loading';
import NoDataPage from '@/components/NoDataPage';
import AutoPavilion from "@/components/AutoPavilion";
import News from "@/components/News";
import { base } from "@/services/api/_base";

const { apis } = services;

function TabHome(props: any) {
  const {
    mark,
    setMark,
    activeIdFn,
    pId,
    getModuleTcArr,
    mallTest,
    _pvMoudel,
    _adMoudel,
    brandId,
  } = props;
  const [loading, setLoading] = useState<boolean>(true);
  const [modules, setModules] = useState<any[]>([]);
  const [display, setDisplay] = useState<boolean>(false);
  const [modulesRes, setModulesRes] = useState<object[]>([]);
  const [moduleInit, setModuleInit] = useState<object[]>([]);
  const [moduleTM, setModuleTM] = useState<any>({});
  const [moduleBK, setModuleBK] = useState<any>({});
  const [moduleHB, setModuleHB] = useState<any>({});
  const [moduleMR, setModuleMR] = useState<any>({});
  const [module3D, setModule3D] = useState<any>({});

  const pageScroll = () => {
    //把内容滚动指定的像素数（第一个参数是向右滚动的像素数，第二个参数是向下滚动的像素数）
    window.scrollBy(0, -200);
    //延时递归调用，模拟滚动向上效果
    const scrolldelay = setTimeout(() => pageScroll(), 100);
    //获取scrollTop值，声明了DTD的标准网页取document.documentElement.scrollTop，否则取document.body.scrollTop；因为二者只有一个会生效，另一个就恒为0，所以取和值可以得到网页的真正的scrollTop值
    var sTop = document.documentElement.scrollTop + document.body.scrollTop;
    //判断当页面到达顶部，取消延时代码（否则页面滚动到顶部会无法再向下正常浏览页面）
    sTop === 0 && clearTimeout(scrolldelay);
  };

  const addTab = (obj: any) => {
    return Object.assign(
      { ...obj },
      {
        currentTab: mark.pageType,
      }
    );
  };

  // 请求商品列表
  const getGoodsListFn = async (
    params: object,
    type: string,
    goodsModuleArr: any[]
  ) => {
    try {
      const res = await apis.getGoodsList(params);
      if (Number(res.returncode) === 0) {
        const _data = _.cloneDeep((res || {}).result || {});
        const goodsObj = _.cloneDeep(_data);
        if (type === "TM") {
          const _module = utils.getmoduleZDY(0, goodsModuleArr, goodsObj);
          setModuleTM(() => addTab(_module));
        }
        if (type === "BK") {
          const _module = utils.getmoduleZDY(1, goodsModuleArr, goodsObj);
          setModuleBK(() => addTab(_module));
        }
        if (type === "HB") {
          const _module = utils.getmoduleZDY(2, goodsModuleArr, goodsObj);
          setModuleHB(() => addTab(_module));
        }
        if (type === "MR") {
          const _module = utils.getmoduleZDY(999, goodsModuleArr, goodsObj);
          setModuleMR(() => addTab(_module));
        }
        if (type === "3D") {
          const _module = utils.getmoduleZDY(10, goodsModuleArr, goodsObj);
          setModule3D(() => addTab(_module));
        }
      } else {
        alert(res.message || "");
      }
    } catch (e) {
      console.log(e);
    } finally {
    }
  };

  // 主体信息接口
  const getModelViewFn = async () => {
    setLoading(() => true);
    const params = {
      providerId: pId,
      sourceType: 2, // pc: 1, m: 2
      pageType: mark.pageType, // tab类型
      isPreview: utils_1.getUrlParam("isPreview") || 0,
    };
    try {
      const res = await apis.getModelView(params);
      if (res.returncode === 0) {
        const _data = (res || {}).result || {};
        let _ms = _.cloneDeep(_data.siteUserPageRowModules || []);
        setModulesRes(() => _ms);
        if (!_ms || _ms.length < 1) {
          setModuleInit(() => []);
          return;
        }
        _ms = utils.sortFn(utils.formatModules(_ms));
        // 需处理自定义商品列表（包含红包和爆款商品） 默认商品列表/ 请求搜索商品接口
        // 先把_ms中需要请求搜索商品接口的数据去掉
        const _initMs = _ms.filter(
          (v: any) =>
            v.siteModuleId !== 8 &&
            v.siteModuleId !== 1 &&
            v.siteModuleId !== 16
        );
        setModuleInit(() => _initMs);
        // 1----自定义商品列表（包含红包和爆款商品）统一处理
        let _zdyGoodsModuleArr = _ms.filter((v: any) => v.siteModuleId === 8);
        if (_zdyGoodsModuleArr.length > 0) {
          // 获取到请求参数
          const _paramsArr = _zdyGoodsModuleArr.map((v: any, k: number) => {
            const styleType = v.siteUserCustomGoods.styleType;
            const goodsIds = v.siteUserCustomGoods.goodsIds || "";
            const _p = {
              q: "",
              provider_id: pId,
              // provider_id: 85011607,
              bizid: goodsIds,
              styleType,
            };
            if (!base.isProduct) {
              return {
                ..._p,
                used_test: 1,
              };
            }
            return { ..._p };
          });

          // 请求——自定义商品列表
          _paramsArr.forEach((v: any) => {
            // 特卖商品
            if (v.styleType === 0) {
              delete v["styleType"];
              getGoodsListFn(v, "TM", _zdyGoodsModuleArr);
            }
            // 爆款商品
            if (v.styleType === 1) {
              delete v["styleType"];
              getGoodsListFn(v, "BK", _zdyGoodsModuleArr);
            }
            // 红包
            if (v.styleType === 2) {
              delete v["styleType"];
              getGoodsListFn(v, "HB", _zdyGoodsModuleArr);
            }
          });
        }
        // 2---默认商品列表
        const _mrGoodsModule = _ms.filter((v: any) => v.siteModuleId === 1);

        if (_mrGoodsModule.length > 0) {
          let params: any = {
            q: "",
            used_test: 1, // 线上不需要
            provider_id: pId,
          };
          base.isProduct && delete params["used_test"];
          getGoodsListFn(params, "MR", _mrGoodsModule);
        }

        // 【3D看车的商品列表】和【默认商品列表】一致，为了保持逻辑清晰，分别请求
        const ZDGoodsModule = _ms.filter((v: any) => v.siteModuleId === 16);
        if (ZDGoodsModule.length > 0) {
          const goodsIds = ZDGoodsModule[0].siteUser3dCar.goodsIds || "";
          let params: any = {
            q: "",
            provider_id: pId,
            bizid: goodsIds,
            used_test: 1, // 线上不需要
          };
          base.isProduct && delete params["used_test"];
          getGoodsListFn(params, "3D", ZDGoodsModule);
        }

        // 3---悬浮组件
        let _tcModuleArr = _ms.filter((v: any) => v.siteModuleId === 11);
        if (_tcModuleArr.length > 0 && getModuleTcArr) {
          getModuleTcArr(_tcModuleArr);
        }
      } else {
        alert(res.message || "");
      }
    } catch (e) {
      console.log(e);
    } finally {
      setLoading(() => false);
    }
  };

  // 根据三个自定义商品module和默认商品module得到最终的modules
  useEffect(() => {
    if (modulesRes?.length > 0) {
      let lastModule = _.cloneDeep([
        ...moduleInit,
        ...[moduleTM],
        ...[moduleBK],
        ...[moduleHB],
        ...[moduleMR],
        ...[module3D],
      ]);
      // [8, 1, 16]过滤的是商品模块，要不然切换tab时，可能保留上一个tab的商品模块内容
      lastModule = lastModule.filter(
        (v: any) =>
          v &&
          v.length !== 0 &&
          JSON.stringify(v) !== "{}" &&
          (([8, 1, 16].includes(v.siteModuleId) &&
            v.currentTab === mark.pageType) ||
            ![8, 1, 16].includes(v.siteModuleId))
      );
      setModules(() => utils.sortFn(lastModule));
    } else {
      setModules([]);
    }
  }, [
    moduleInit,
    JSON.stringify(moduleTM),
    JSON.stringify(moduleBK),
    JSON.stringify(moduleHB),
    JSON.stringify(moduleMR),
    JSON.stringify(module3D),
    mark,
  ]);

  useEffect(() => {
    if (!mark?.pageType) {
      return;
    }
    getModelViewFn();
  }, [mark?.pageType]);

  useEffect(() => {
    document
      .getElementsByTagName("section")[0]
      .addEventListener("touchmove", function (e) {
        let _st = document.documentElement.scrollTop;
        if (_st > window.screen.height && !display) {
          setDisplay(() => true);
        }
        if (_st < window.screen.height && !display) {
          setDisplay(() => false);
        }
      });
  }, []);

  // 店铺首页pv、uv埋点
  useEffect(() => {
    if (mark.pageType === "mall") {
      let extendParams = {
        ...dd.ep,
        providerId: pId,
        mallTest,
      };
      extendParams = utils_1.formatParams(extendParams);
      utils_1.pvTrackLogger(
        "show",
        "ec_topic_mall_pv_show",
        {
          ...dd.baseParams,
          area: "top",
        },
        extendParams
      );
      utils_1.pvTrackLogger(
        "show",
        "ec_topic_mall_uv_show",
        {
          ...dd.baseParams,
          area: "top",
        },
        extendParams
      );
    }
  }, []);

  if (loading) {
    return <Loading />;
  }

  if (!loading && modulesRes && modulesRes.length === 0) {
    return <NoDataPage />;
  }

  return (
    <div className="tabHome">
      {modules.map((v: any, index) => {
        const { sort } = v;
        // 轮播图
        if (v.siteModuleId === 2) {
          const {
            siteUserCarouselFigure: {
              pictureLinkList,
              siteUserCarouselFigureId,
              moduleName,
            },
          } = v;
          return (
            <>
              <span className="title">{moduleName}</span>
              <Carousel
                id={sort}
                list={pictureLinkList}
                compId={siteUserCarouselFigureId}
                mark={mark}
                pId={pId}
                mallTest={mallTest}
                _pvMoudel={_pvMoudel}
                _adMoudel={_adMoudel}
                key={index}
              />
            </>
          );
        }
        // 通栏图
        if (v.siteModuleId === 3) {
          const { siteUserBanner } = v;
          return (
            <BannerImg
              id={sort}
              data={siteUserBanner}
              mark={mark}
              pId={pId}
              mallTest={mallTest}
              key={index}
            />
          );
        }
        // 红包
        if (v.siteModuleId === 8 && v.siteUserCustomGoods.styleType === 2) {
          const {
            siteUserCustomGoods: {
              goodsObj: { cost, rowcount, list },
              siteUserCustomGoodsId,
              moduleName,
            },
          } = v;
          if (list && list.length === 0) {
            return null;
          }
          return (
            <RedPacket
              id={sort}
              list={list}
              compId={siteUserCustomGoodsId}
              mark={mark}
              pId={pId}
              mallTest={mallTest}
              _pvMoudel={_pvMoudel}
              _adMoudel={_adMoudel}
              key={index}
            />
          );
        }
        // 爆款商品
        if (v.siteModuleId === 8 && v.siteUserCustomGoods.styleType === 1) {
          const { siteUserCustomGoods } = v;
          const {
            siteUserCustomGoodsId,
            goodsObj: { cost, rowcount, list },
            moduleName,
          } = siteUserCustomGoods;
          if (list && list.length === 0) {
            return null;
          }
          return (
            <BKGoods
              id={sort}
              list={list}
              compId={siteUserCustomGoodsId}
              moduleName={moduleName}
              mark={mark}
              pId={pId}
              mallTest={mallTest}
              _pvMoudel={_pvMoudel}
              _adMoudel={_adMoudel}
              key={index}
            />
          );
        }
        // 默认商品活动列表
        if (v.siteModuleId === 1) {
          const {
            siteUserActivityList: {
              goodsObj: { cost, row, list },
              moduleName,
              siteUserActivityListId,
            },
          } = v;
          if (list && list.length === 0) {
            return null;
          }
          return (
            <div key={index} className="tabHome-item tabHome-item-MR">
              <span className="title">{moduleName}</span>
              <DefaultGoodsList
                keys="MR"
                list={list}
                row={row}
                mark={mark}
                setMark={setMark}
                compId={siteUserActivityListId}
                activeIdFn={activeIdFn}
                pId={pId}
                mallTest={mallTest}
                _pvMoudel={_pvMoudel}
                _adMoudel={_adMoudel}
              />
            </div>
          );
        }
        // 特卖商品（自定义商品列表-跳转到商品tab页、默认商品列表-加载更多）
        if (v.siteModuleId === 8 && v.siteUserCustomGoods.styleType === 0) {
          const {
            siteUserCustomGoods: {
              goodsObj: { cost, rowcount, list },
              moduleName,
              siteUserCustomGoodsId,
            },
          } = v;
          if (list && list.length === 0) {
            return null;
          }
          return (
            <div key={index} className="tabHome-item tabHome-item-TM">
              <span className="title">{moduleName}</span>
              <DefaultGoodsList
                keys="TM"
                mark={mark}
                list={list}
                row={rowcount}
                compId={siteUserCustomGoodsId}
                pId={pId}
                mallTest={mallTest}
                _pvMoudel={_pvMoudel}
                _adMoudel={_adMoudel}
              />
            </div>
          );
        }
        // 自定义图片
        if (v.siteModuleId === 15) {
          const { siteUserCustomPic } = v;
          return (
            <CustomizeImg
              id={sort}
              data={siteUserCustomPic}
              mark={mark}
              pId={pId}
              mallTest={mallTest}
              key={index}
            />
          );
        }
        // 中心二分图
        if (v.siteModuleId === 5) {
          const {
            siteUserCenterDichotomize: {
              pictureLinkList,
              siteUserCenterDichotomizeId,
            },
          } = v;
          return (
            <CenterSecond
              id={sort}
              list={pictureLinkList}
              compId={siteUserCenterDichotomizeId}
              mark={mark}
              pId={pId}
              mallTest={mallTest}
              key={index}
            />
          );
        }
        // 中心三分图
        if (v.siteModuleId === 6) {
          const {
            siteUserCenterThirds: { pictureLinkList, siteUserCenterThirdsId },
          } = v;
          return (
            <CenterThird
              id={sort}
              list={pictureLinkList}
              compId={siteUserCenterThirdsId}
              mark={mark}
              pId={pId}
              mallTest={mallTest}
              key={index}
            />
          );
        }
        // 视频
        if (v.siteModuleId === 9) {
          const { siteUserVideo } = v;
          return (
            <>
              <span className="title">{siteUserVideo?.moduleName}</span>
              <VideoView
                id={sort}
                data={siteUserVideo}
                mark={mark}
                pId={pId}
                mallTest={mallTest}
                key={index}
              />
            </>
          );
        }
        // 3D汽车馆
        if (v.siteModuleId === 16) {
          const { siteUser3dCar } = v;
          if (!(siteUser3dCar.goodsObj?.list?.length > 0)) {
            return null;
          }
          return (
            <div
              key={index}
              className="tabHome-item tabHome-item-auto-pavilion"
            >
              <span className="title">{siteUser3dCar?.moduleName}</span>
              <AutoPavilion
                id={sort}
                data={siteUser3dCar}
                mark={mark}
                pId={pId}
                mallTest={mallTest}
              ></AutoPavilion>
            </div>
          );
        }
        // 前言资讯、品牌新闻
        // 3D汽车馆
        if (v.siteModuleId === 17) {
          const { siteUserRecentNews } = v;
          return (
            <div key={index} className="tabHome-item tabHome-item-news">
              <span className="title">{siteUserRecentNews?.moduleName}</span>
              <News
                id={sort}
                data={siteUserRecentNews}
                mark={mark}
                pId={pId}
                mallTest={mallTest}
                brandId={brandId}
              ></News>
            </div>
          );
        }
      })}
    </div>
  );
}

export default TabHome;
